/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from "zod/v4";

export const goodLuckCoreDTOsMatchHistoryKdaDtoSchema = z.object({
  kills: z.optional(z.int()),
  deaths: z.optional(z.int()),
  assists: z.optional(z.int()),
});
